// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zksyncInMemoryNode as _zksyncInMemoryNode } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zksyncInMemoryNode chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 260
 * Chain Name: ZKsync InMemory Node
 * Default Block Explorer: Not specified
 * Default RPC URL: http://localhost:8011
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zksyncInMemoryNode } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zksyncInMemoryNode,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zksyncInMemoryNode = createCommon({
	..._zksyncInMemoryNode,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
